module.exports = __webpack_public_path__ + "static/equipe-b91969a0a03caa6236053d655beeb0fb.jpg";